const IFRAME_WHITELIST = [
  {
    hostname: "om.omni.se",
    pathPrefixes: ["/a", "/omnipod", "/omnipodd"],
  },
] as const;

export type ExternalArticleBodyMode = "none" | "iframe" | "external-link";

const matchesWhitelistedPath = (pathname: string, pathPrefix: string) => {
  return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
};

const getExternalArticleBodyMode = (
  teaserLink?: string,
): ExternalArticleBodyMode => {
  if (!teaserLink) {
    return "none";
  }

  try {
    const { hostname, pathname } = new URL(teaserLink);

    const isWhitelisted = IFRAME_WHITELIST.some(
      ({ hostname: allowedHostname, pathPrefixes }) =>
        hostname === allowedHostname &&
        pathPrefixes.some((pathPrefix) =>
          matchesWhitelistedPath(pathname, pathPrefix),
        ),
    );

    return isWhitelisted ? "iframe" : "external-link";
  } catch {
    return "external-link";
  }
};

export { getExternalArticleBodyMode };
